import React, {memo, forwardRef} from "react";
import {Text} from "react-native";
import colors from "../colors";
import {LegacyStyleProps, TypographyBaseProps, TypographyWeight} from "./types";

// this is the type for the publicly exported component. Since it'll be
// shared among pro/consumer, it can live in base.
export type ParagraphProps = TypographyBaseProps &
  LegacyStyleProps &
  TypographyWeight & {
    // level 1 - largest, 3 - smallest
    level?: 1 | 2 | 3;
    numberOfLines?: number;
  };

type BaseParagraphProps = TypographyBaseProps;

const Paragraph = forwardRef<Text, BaseParagraphProps>(function Paragraph(
  {style, color = colors.gray[1000], ...props},
  ref,
) {
  return <Text ref={ref} {...props} style={[style, {color}]} />;
});

export default memo(Paragraph);
